import actionTypes from '../../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_SFTP_LIST_SUCCESS:
      return [...action.sftpList]
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/reducers/sftp/sftp-list.js